export class PaginationModel {
    currentPage = 1;
    itemsPerPage = 50;
    itemsPerPageOptions: number[] = [10, 25, 50, 100];

    constructor(init?: Partial<PaginationModel>) {
        Object.assign(this, init);
    }
}
